module.exports = __webpack_public_path__ + "img/individual_education.8721bd5c.svg";